import type { Asset, PlayerAsset, Scene } from "../types";

export interface SceneCoordinateBounds {
  width: number;
  height: number;
}

type CoordinateAsset = Pick<Asset | PlayerAsset, "id" | "width" | "height">;
type MediaDimensions = Pick<Asset | PlayerAsset, "width" | "height"> & { id?: string };

const finiteDimension = (value: number | undefined) => Number.isFinite(value) && (value ?? 0) > 0 ? value! : undefined;

/**
 * Media annotations use a stable 100-unit-wide coordinate system whose height
 * follows the source aspect ratio. That keeps circles circular and positions
 * portable across DM, projector, contain, cover, and resized windows.
 */
export function mediaCoordinateBounds(asset?: MediaDimensions): SceneCoordinateBounds {
  const width = finiteDimension(asset?.width) ?? 1;
  const height = finiteDimension(asset?.height) ?? width;
  return { width: 100, height: 100 * height / width };
}

export function sceneCoordinateBounds(scene: Scene, assets: CoordinateAsset[] = []): SceneCoordinateBounds | undefined {
  if (scene.geometry) return { width: scene.geometry.width, height: scene.geometry.height };
  if (scene.type !== "image" && scene.type !== "video") return undefined;
  return mediaCoordinateBounds(assets.find((asset) => asset.id === scene.assetId));
}
